import { useState } from "react";

import { InformationIcon, SectionHeader } from "~/common/components";
import { PATIENT_PREVIEW_KEYS, patientPreviewData } from "~/providers/utils";
import { PatientPreviewInfoModal } from "../../common";

export const SelfReportedScoresTitle = () => {
  const [showInfoModal, setShowInfoModal] = useState(false);

  const { description, bottomDescription, options } =
    patientPreviewData[PATIENT_PREVIEW_KEYS.self_reported];

  return (
    <>
      <div className="flex items-center gap-2">
        <SectionHeader>Self-reported scores</SectionHeader>
        <button onClick={() => setShowInfoModal(true)}>
          <InformationIcon className="size-4 text-gray-20" />
        </button>
      </div>
      <PatientPreviewInfoModal
        show={showInfoModal}
        onClose={() => setShowInfoModal(false)}
        title="Self-reported scores"
        description={description}
        options={options}
        bottomDescription={bottomDescription}
      />
    </>
  );
};
